import { getMobileMenu, getPages, mobileMenuQueryKey, pagesQueryKey } from "@/api";
import type { Session } from "@/contracts";
import { queryClient } from "@/lib/query-client";

// O loader roda depois da guarda de sessão. A primeira montagem do shell já
// recebe páginas e atalhos; navegações seguintes reutilizam o cache do Query.
export async function loadShellNavigation(session: Session) {
  // A administração da empresa também funciona sem uma marca ativa; essas
  // consultas pertencem à marca e não podem impedir a entrada em /company.
  if (!session.identity.tenantId) return;

  await Promise.all([
    queryClient.fetchQuery({ queryKey: pagesQueryKey, queryFn: getPages }),
    queryClient.fetchQuery({ queryKey: mobileMenuQueryKey, queryFn: getMobileMenu }),
  ]);
}
